import React from 'react';
import { Link } from 'react-router-dom';
import './FruitCard.css';

const FruitCard = ({ fruit }) => {
  const imageUrl = require(`../assets/svg/${fruit.image}`);

  return (
    <Link to={`/fruit/${fruit.id}`} className="fruit-card">
      <div className="fruit-card-image-container">
        <img src={imageUrl} alt={fruit.name} className="fruit-card-image" />
      </div>
      <div className="fruit-card-content">
        <h3>{fruit.name}</h3>
        <p>{fruit.benefits[0].description}</p>
      </div>
    </Link>
  );
};

export default FruitCard;
